/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/naming-convention */
import { watch, onMounted } from 'vue';
import { useAvailableFeatureCheck } from '@/composable/available-feature-check';
import { useCurrentUserProvider } from '@/composable/current-user';

declare global {
  interface Window {
    Intercom: (...args: unknown[]) => void;
  }
}

export const useIntercom = () => {
  if (process.env.NODE_ENV !== 'production') return;

  const { isAvailableIntercomFeature } = useAvailableFeatureCheck();
  const { inject: injectCurrentUser } = useCurrentUserProvider();
  const { currentUser } = injectCurrentUser();

  onMounted(() => {
    watch(
      () => [isAvailableIntercomFeature.value, currentUser.value],
      () => {
        if (typeof window.Intercom !== 'function') throw new Error('intercom is not set');
        if (!isAvailableIntercomFeature.value) return window.Intercom('shutdown');
        if (!currentUser.value) return;

        window.Intercom('boot', {
          app_id: 'u5oi15m2',
          name: currentUser.value.name,
          email: currentUser.value.email,
          user_id: currentUser.value.id,
          created_at: currentUser.value.createdAt,
          client_name: currentUser.value.clientName,
        });
      },
    );
  });
};
